import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'

import Input from '../../../form/Input'
import Button from '../../../../UniformComponents/Button'
import Checkbox from '../../../form/Checkbox'
import CheckboxGroup from '../../../form/CheckboxGroup'
import Select from '../../../form/Select'
import BenchmarkTestModal from './BenchmarkTestModal'

@observer
class Benchmarks extends Component {
    constructor(props) {
        super(props)

        const {
            store,
            register,
            name,
            path,
        } = props
        const { customTag } = store

        if (typeof register === 'function') {
            register(name, this.validate, path)
        }

        if (R.pathOr([], ['config', 'benchmarkRules'], customTag).length === 0) {
            customTag.config.benchmarkRules = [{
                uuid: uuidv4(),
                config: {
                    name: '',
                    rules: [],
                },
            }]
        }
    }

    componentWillUnmount() {
        const {
            unregister,
            name,
            path,
        } = this.props

        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    validate = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag

        return !R.isEmpty(config.benchmarkOptions)
    }

    optionsNameBlur = ({ value }, index) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { benchmarkRules } = config
        const option = benchmarkRules[index]
        option.config.name = value
    }

    addOption = () => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { benchmarkRules } = config
        benchmarkRules.push(
            {
                uuid: uuidv4(),
                name: '',
                config: {
                    rules: [],
                },
            },
        )
    }

    removeOption = (optionId) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        const { benchmarkRules } = config

        config.benchmarkRules = benchmarkRules
            .slice()
            .filter(({ uuid }) => uuid !== optionId)
    }

    renderOptions = () => {
        const { store } = this.props
        const {
            customTag, toggleShowBenchmarksModal, setBenchamrkOptionIndex, toggleTestBenchmark,
        } = store
        const { config } = customTag
        const { benchmarkRules } = config

        return (
            <div className="benchmarkOptions">
                {benchmarkRules.map((bo, i) => (
                    <div className="benchmarkOption" key={bo.uuid}>
                        <Input
                            placeholder="Name"
                            defaultValue={bo.config.name}
                            onBlur={(obj) => this.optionsNameBlur(obj, i)}
                        />
                        <i
                            className="fa-solid fa-gear"
                            onClick={() => {
                                setBenchamrkOptionIndex(i)
                                toggleShowBenchmarksModal()
                            }}
                        />
                        {bo.id ? (
                            <Button
                                label="Test"
                                onClick={() => toggleTestBenchmark(bo.id)}
                            />
                        ) : null}
                        <i
                            className="fal fa-trash"
                            onClick={() => this.removeOption(bo.uuid)}
                        />
                    </div>
                ))}
                <div>
                    <Button
                        label="Add Option"
                        onClick={this.addOption}
                        cssClass="primary secondary"
                    />
                </div>
            </div>
        )
    }

    setTagBenchmark = (value) => {
        const { store } = this.props
        const { onBlur } = store
        const { customTag } = store
        const { config } = customTag

        if (value) {
            onBlur({ type: 'checkboxgroup', value: [...customTag.options, 'tagBenchmark'] }, null, null, ['options'])
        } else {
            config.benchmarkRules = [{
                uuid: uuidv4(),
                config: {
                    name: '',
                    rules: [],
                },
            }]
            onBlur({ type: 'checkboxgroup', value: R.without(['tagBenchmark'], customTag.options.slice()) }, null, null, ['options'])
        }
    }

    setBenchmarkTag = (value) => {
        const { store } = this.props
        const { customTag } = store
        const { config } = customTag
        config.benchmarkRules = [{
            uuid: uuidv4(),
            config: {
                name: 'Tag benchmark',
                tagId: value,
                rules: [],
            },
        }]
    }

    render() {
        const { store } = this.props
        const { onBlur } = store
        const { customTag, tagList, toggleTestBenchmark } = store
        const { oid, clientId } = customTag

        const isTagBased = customTag.options.includes('tagBenchmark')

        return (
            <div id="benchmarks">
                <CheckboxGroup
                    name="benchmarks"
                    path={['config', 'benchmarkOptions']}
                    label={i18n.t('customTag.benchmarkOptions')}
                    options={[
                        {
                            value: 'publish',
                            label: i18n.t('customTag.benchmarkOptions.publish'),
                        },
                        {
                            value: 'industry',
                            label: i18n.t('industry'),
                        },
                        {
                            value: 'company',
                            label: i18n.t('dashboard.benchmarks.company'),
                        },
                    ]}
                    isMandatory
                    defaultChecked={R.pathOr([], ['config', 'benchmarkOptions'], customTag)}
                    onBlur={(obj) => onBlur(obj, null, null, ['config', 'benchmarkOptions'])}
                    returnValueUnchanged
                    checkboxClassName="exploriNativeCheckbox"
                    refreshOnRender
                />
                <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                    <Checkbox
                        name="tagBasedBenchmark"
                        label={i18n.t('customTag.benchmarks.customTagBenchmarks.tagBased')}
                        className="exploriNativeCheckbox"
                        defaultChecked={R.pathOr([], ['options'], customTag).includes('tagBenchmark')}
                        onBlur={({ value }) => this.setTagBenchmark(value)}
                    />
                </div>

                {isTagBased ? (
                    <div style={{ marginTop: '15px', display: 'flex' }}>
                        <Select
                            name="BenchmarkTag"
                            label={i18n.t('customTag')}
                            options={tagList
                                .filter((t) => (
                                    ['SB', 'CH'].includes(t.questionType)
                                    && t.options.includes('mergefield')
                                    && [3, 4, 5, 6, 7].includes(t.oid)
                                    && (t.clientId === clientId || t.clientId === 0)
                                ))
                                .map((t) => ({ label: t.name, value: t.id }))}
                            onBlur={({ value }) => this.setBenchmarkTag(value)}
                            defaultValue={R.pathOr(undefined, ['config', 'benchmarkRules', 0, 'config', 'tagId'], customTag)}
                        />
                        <div style={{ marginTop: '30px', marginLeft: '15px' }}>
                            <Button
                                label="Test"
                                onClick={() => toggleTestBenchmark(true)}
                                disabled={!R.pathOr(false, ['config', 'benchmarkRules', 0, 'config', 'tagId'], customTag)}
                            />
                        </div>

                    </div>
                ) : (
                    <fieldset id="benchmarks">
                        <legend>Benchmark Options</legend>
                        {
                            oid === 9 ? this.renderOptions() : null
                        }
                    </fieldset>
                )}
                <BenchmarkTestModal
                    store={store}
                />
            </div>
        )
    }
}

export default Benchmarks
